import React from 'react';
import ReactDOM from 'react-dom';
import '@progress/kendo-theme-default/dist/all.css';
import '../../leads/kendo-override.css'
import SpaceConfigurationsApp from './apps/SpaceConfigurationsApp';

const e = React.createElement;

const configsContainer = document.querySelector('#configurationscomponent');

if (configsContainer) {
    ReactDOM.render(e(SpaceConfigurationsApp, { templateContainerID: configsContainer.dataset.templateId, configContainerID: configsContainer.dataset.configId }), configsContainer);
}